import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import userStore from '../../Stores/User';
import { linkNewEmail, deleteUser } from '../../audiblogsApi';
import mixpanel from 'mixpanel-browser';
import { useHistory } from 'react-router-dom';
import loadingIcon from "../../Assets/loading.gif"
import queryString from 'query-string';
import Checkout from '../Checkout';

// import "./index.scss";

const Account = observer(() => {
  const { logOut, idToken, isSignedIn, user, creditsHd,
    creditsSd } = userStore;
  const [deletedData, setDeletedData] = useState(false);
  const history = useHistory();

  useEffect(() => {
    mixpanel.track('Open Account Page');

  }, []);


  useEffect(() => {

    if (isSignedIn === false && deletedData === false) {
      // If not signed in, redirect to signin
      history.push(`/signin`);
    } else if (isSignedIn === false && deletedData === true) {
      history.push(`/bye`);;
    }
  }, [isSignedIn, idToken]);

  return (
    <div className="center">
      {user === null ? (
        <img src={loadingIcon} style={{ height: '16px' }} />
      ) : (
        <>
  
        {creditsHd && creditsHd > 0 && (
          <div>{creditsHd} HD hours</div>
        )}
  
        {creditsSd && creditsSd > 0 && (
          <div>{creditsSd} SD hours</div>
        )}

        {/* <Checkout /> */}
  
        {user.subscriptions && (
          user.subscriptions.hd || user.subscriptions.sd && (
            // User is subscribed to the new plan
            <>
              <div style={{ marginTop: '10px', width: "257px" }}>
                <Link className="transparent-button mobile" to={`/subscribe`}>
                  <span>Buy Credits</span>
                </Link>
              </div>

            </>
          )
        )}
        {userStore.customerPortalUrl && (
          <a
            href={userStore.customerPortalUrl}
            target="_blank"
            className="transparent-button mobile"
            style = {{ width: "245px"}}
          >
            Manage Billing
          </a>
        )}

        </>
      )}

      <div className="account-sub-div">

        <div >
          {/* Create a button that confirms the user using alert */}
          {/* <button 
            className="transparent-button mobile"
            style ={{color: 'red', fontWeight: "normal", border: "1px solid red", fontSize: "10px", cursor: "pointer"}}
            onClick={(e) => {
              if (
                window.confirm('Are you sure you want to delete your account? This cannot be undone.')
              ) {
                deleteUser(idToken)
                  .then((data) => {
                    setDeletedData(true);
                    window.alert('Account deleted. Logging out...')
                    logOut()
                    // console.log(data);
                  })
                  .catch((err) => {
                    console.log(err);
                    alert(
                      'Error deleting account. Please contact eric at audioread.com'
                    );
                  });
              }
            }}
          >
            Delete Account & Subscription 
          </button> */}
        <div style={{ marginTop: '10px'}}>
          <Link className="transparent-button mobile" onClick={logOut}>
            Log Out
          </Link>
        </div>

          {deletedData && <div>Account removed. Loging out...</div>}
        </div>
        <div style={{ marginTop: '10px'}}>
          <Link to="/add" style={{ textDecoration: 'none', color: 'inherit' }}>
            Go Back
          </Link>
        </div>
      </div>
    </div>
  );
});

export default Account;
